import { render } from "./Notes-main.vue?vue&type=template&id=2eb847f5&scoped=true&lang=pug"
import script from "./Notes-main.vue?vue&type=script&setup=true&lang=js"
export * from "./Notes-main.vue?vue&type=script&setup=true&lang=js"

import "./Notes-main.vue?vue&type=style&index=0&id=2eb847f5&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb847f5"]])

export default __exports__